import { FC, createContext, ReactNode } from "react";
import { Dispatch, SetStateAction, useContext } from "react";
import { getItemsRequest } from "src/store/slices/item/item.type";

type GiftcardsListingContextType = {
  filters: Partial<getItemsRequest>;
  setFilters: Dispatch<SetStateAction<Partial<getItemsRequest>>>;
};

const GiftcardsListingContext = createContext<null | GiftcardsListingContextType>(null);

const GiftcardsListingProvider: FC<{ value: GiftcardsListingContextType; children: ReactNode }> = ({ value, children }) => {
  return <GiftcardsListingContext.Provider value={value}>{children}</GiftcardsListingContext.Provider>;
};

const useGiftcardsListing = () => {
  const context = useContext(GiftcardsListingContext);
  if (!context) throw new Error("Illegal Usage of Context outside the GiftcardsListingContext");
  return context;
};


export {GiftcardsListingProvider,useGiftcardsListing};